import React from 'react';
import { createBrowserRouter, Navigate } from 'react-router';

//components
import { LoadingSpinner } from 'thrive-components';

//pages
import GetStarted from '../pages/GetStarted/GetStarted';
import Details from '../pages/Details/Details';
import Design from '../pages/Design/Design';
import Download from '../pages/Download/Download';
import AppStoreRedirector from '../pages/Redirect/AppStoreRedirector';

//interfaces
import { SignUpStepRoutes, SignUpSteps } from '../interfaces/Navigation';
import { signUpStepLoader } from './loaders/SignUpStepLoader';



const createRouter = () => createBrowserRouter(
    [
        {
            path: "/",
            element:  <Navigate to={SignUpStepRoutes[SignUpSteps.ONBOARDING]} replace={true}/>,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
        {
            path: SignUpStepRoutes[SignUpSteps.ONBOARDING],
            element: <GetStarted />,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
        {
            path: SignUpStepRoutes[SignUpSteps.DETAILS],
            element: <Details />,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
        {
            path: SignUpStepRoutes[SignUpSteps.DESIGN],
            element: <Design />,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
        {
            path:SignUpStepRoutes[SignUpSteps.DOWNLOAD],
            element: <Download />,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
        {
            path:SignUpStepRoutes[SignUpSteps.REDIRECTOR],
            element: <AppStoreRedirector />,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
        {
            path: "*",
            element:  <Navigate to={SignUpStepRoutes[SignUpSteps.ONBOARDING]} replace={true}/>,
            loader: signUpStepLoader,
            hydrateFallbackElement: <LoadingSpinner size={22}/>
        },
    ]
);

export default createRouter